// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__EHHTU","right":"Header_right__13KIP"};